import { Map } from 'immutable';

import { ActionTypes } from '../constants/AppConstants';
import BaseStore from './BaseStore';

export class FareHandOffStore extends BaseStore {

    getInitialState () {
        return new Map({
            loading: false,
            reorderable: null,
        });
    }

    getActionHandlers () {
        return {
            [ ActionTypes.FARE_HANDOFF_LOADING ]: this.handleFareHandOffLoading,
            [ ActionTypes.FARE_HANDOFF_LOADED ]: this.handleFareHandOffLoaded,
        };
    }

    handleFareHandOffLoading () {
        this.setState(
            this.state.merge({ loading: true })
        );
    }

    handleFareHandOffLoaded ({ reorderable }) {
        this.setState(this.state.merge({ loading: false, reorderable }));
    }

}

export default new FareHandOffStore();



// WEBPACK FOOTER //
// ./src/stores/FareHandOffStore.js